import React, { useState } from "react";
import { useTransition, animated } from "react-spring";
import ProgressBar from "../../ProgressBar";
import NextBackButton from "../../NextBackButton";

export const WhenAreYouLooking = ({ formData, setForm, navigation, step }) => {
  const [error, setError] = useState(false);

  const [isVisible, setIsVisible] = useState(true);

  const whenAreYouLooking = [
    { id: "1-3 Months", title: "Within 30 Days" },
    { id: "3-6 Months", title: "3-6 Months" },
    { id: "> Year", title: "12+ Months" },
    { id: "Undecided", title: "Undecided" },
  ];

  const transition = useTransition(isVisible, {
    from: { opacity: 0, transform: "translate3d(500px,0px,0)" },
    enter: { opacity: 1, transform: "translate3d(0,0px,0)" },
  });
  const checkForNextStep = () => {
    if (formData.whenAreYouLooking === "") {
      setError(true);
      console.log("error");
    }
    if (formData.whenAreYouLooking !== "") {
      navigation.next();
      console.log("next");
    }
  };

  return (
    <div className="flex flex-col h-screen w-full">
      <ProgressBar width={"25%"} />
      <div className="flex-grow max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-center items-center h-full">
        {transition((style, item) =>
          item ? (
            <animated.div style={style} className="mx-auto flex flex-col justify-center items-center h-1/2">
              <h1 className="pb-10 text-4xl text-blue-primary font-semibold text-center w-full">
                When are you looking to achieve this goal?
              </h1>
              <div>
                <label className="text-base font-medium text-gray-900"></label>
                <fieldset className="">
                  <legend className="sr-only">When are you looking to achieve this goal?</legend>
                  <div className="space-y-3">
                    {whenAreYouLooking.map((times) => (
                      <div key={times.id} className="flex items-center">
                        <input
                          onChange={setForm}
                          checked={formData.whenAreYouLooking === times.id}
                          value={times.id}
                          id={times.id}
                          name="whenAreYouLooking"
                          type="radio"
                          className="h-4 w-4 text-white border-gray-satan"
                        />
                        <label htmlFor={times.id} className="ml-3 block text-xl font-medium text-gray-satan">
                          {times.title}
                        </label>
                      </div>
                    ))}
                    {error ? <p className="text-red-error">Please fill out an answer</p> : null}
                  </div>
                </fieldset>
              </div>
            </animated.div>
          ) : null
        )}
      </div>
      <NextBackButton callBack={checkForNextStep} goBack={() => navigation.previous()} />
    </div>
  );
};
